import React from "react";
import styled from "styled-components";
import { FaShopify, FaInstagram, FaYoutube } from "react-icons/fa";

const FooterWrapper = styled.footer`
  background: #000000;
  padding: 80px 0 40px;
  border-radius: 50px 50px 0 0;
`;

const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FooterContent = styled.div`
  display: flex;
  gap: 80px;

  @media (max-width: 992px) {
    flex-direction: column;
    gap: 40px;
  }
`;

const NavigationSection = styled.div`
  display: grid;
  padding: 0 40px;
  grid-template-columns: repeat(3, 1fr);
  gap: 60px;
  flex: 1;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const FooterColumn = styled.div`
  text-align: center;

  @media (min-width: 992px) {
    text-align: left;
  }
`;

const SocialColumn = styled.div`
  text-align: center;
`;

const FooterTitle = styled.h4`
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const FooterLink = styled.a`
  color: #999;
  text-decoration: none;
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
  transition: color 0.2s;
  cursor: pointer;

  &:hover {
    color: #fff;
  }
`;

const FooterText = styled.p`
  color: #999;
  font-size: 14px;
  margin-bottom: 10px;
  line-height: 1.6;
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
`;

const SocialLink = styled.a`
  color: #999;
  font-size: 18px;
  transition: color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #999;

  &:hover {
    color: #fff;
    border-color: #fff;
  }
`;

const Divider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 40px 0 20px;
`;

const Copyright = styled.div`
  color: #999;
  font-size: 14px;
  text-align: center;
`;

const Footer = () => {
  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <FooterWrapper>
      <FooterContainer>
        <FooterContent>
          <NavigationSection>
            <FooterColumn>
              <FooterTitle>Company</FooterTitle>
              <FooterLink onClick={() => handleScroll("personnel")}>
                About Us
              </FooterLink>
              <FooterLink onClick={() => handleScroll("workflow")}>
                Workflow
              </FooterLink>
              <FooterLink onClick={() => handleScroll("sourcing")}>
                Sourcing
              </FooterLink>
              <FooterLink onClick={() => handleScroll("shipping")}>
                Shipping
              </FooterLink>
            </FooterColumn>

            <FooterColumn>
              <FooterTitle>Support</FooterTitle>
              <FooterLink onClick={() => handleScroll("contact")}>
                Help Center
              </FooterLink>
              <FooterLink
                href="https://dropshipindia.live/privacy.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </FooterLink>
              <FooterLink
                href="https://dropshipindia.live/tnc.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </FooterLink>
            </FooterColumn>

            <FooterColumn>
              <FooterTitle>Contact</FooterTitle>
              <FooterText>support@dropshipindia.live</FooterText>
            </FooterColumn>
          </NavigationSection>

          <SocialColumn>
            <img
              src="images/ds-white.svg"
              alt="DropshipIndia"
              className="responsive-logo"
            />

            <SocialLinks>
              <SocialLink
                href="https://www.instagram.com/dropshipindia.live/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </SocialLink>
              <SocialLink
                href="https://www.youtube.com/@DropshipIndia-q1g"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube />
              </SocialLink>
              <SocialLink
                href="https://apps.shopify.com/dropship-india"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaShopify />
              </SocialLink>
            </SocialLinks>
          </SocialColumn>
        </FooterContent>

        <Divider />

        <Copyright>
          {new Date().getFullYear()} Dropship India. All rights reserved.
        </Copyright>
      </FooterContainer>
    </FooterWrapper>
  );
};

export default Footer;
